import React from 'react';
import ErrorView from './ErrorView';

const Expired: React.FC = props => {
  return <ErrorView {...props} />;
};

export default Expired;
